(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (function() {
    'use strict';
    
    function initArticleSlider() {
      if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
        setTimeout(initArticleSlider, 100);
        return;
      }
      
      const articleSlider = jQuery('.article-slider');
      
      if (articleSlider.length) {
        articleSlider.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          infinite: true,
          speed: 300,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
        
        jQuery('.article-slider__prev').on('click', function() {
          articleSlider.slick('slickPrev');
        });
        
        jQuery('.article-slider__next').on('click', function() {
          articleSlider.slick('slickNext');
        });
      }
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initArticleSlider);
    } else {
      initArticleSlider();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    'use strict';
    
    // Warte bis jQuery und Slick geladen sind




    function initSlider() {
      if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
        setTimeout(initSlider, 100);
        return;
      }
      
      const mainSlider = jQuery('.product-slider');
      const navItems = jQuery('.product-slider-nav__item');
      
      if (mainSlider.length) {
        // Haupt-Slider
        mainSlider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          infinite: true,
          speed: 300
        });
        
        // Previous/Next Button Handler
        jQuery('.product-slider__prev').on('click', function() {
          mainSlider.slick('slickPrev');
        });
        
        jQuery('.product-slider__next').on('click', function() {
          mainSlider.slick('slickNext');
        });
        
        // Navigation nur wenn vorhanden
        if (navItems.length) {
          // Aktives Thumbnail beim Start setzen
          navItems.eq(0).addClass('active');
          
          // Thumbnail-Klick-Handler
          navItems.on('click', function() {
            const slideIndex = jQuery(this).data('slide-index');
            mainSlider.slick('slickGoTo', slideIndex);
          });
          
          // Aktives Thumbnail aktualisieren wenn Slider sich ändert
          mainSlider.on('afterChange', function(event, slick, currentSlide) {
            navItems.removeClass('active');
            navItems.eq(currentSlide).addClass('active');
          });
        }
      }
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSlider);
    } else {
      initSlider();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
